import { useContext } from "react";
import { MultiContext } from "../../Context";

export default function AccountItem({ item, className = "" }) {
  const multiCtx = useContext(MultiContext);

  return (
    <div
      onClick={() =>
        multiCtx.setSelectedAccount(
          multiCtx.selectedAccount?.id === item.id ? null : item
        )
      }
      className={
        className +
        " account-item" +
        (multiCtx.selectedAccount?.id === item.id ? " active" : "")
      }>
      <div className="d-flex">
        <img
          src={item.thumbnail}
          width={30}
          height={30}
          className="rounded rounded-lg my-auto"
        />
        <div className="ms-3 text-truncate">
          <div className="h6 m-0 fw-bold">{item.name}</div>
          <div className="text-truncate">{item.username}</div>
        </div>
      </div>
    </div>
  );
}
